import React from 'react';
import { Typography, theme } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

const { Text } = Typography;

// 接入向导(CDN / DNS)共用的小部件

/** 可选卡片(与 EVM 购买页同款) */
export const Pick = ({ active, onClick, icon, title, desc, extra, children }) => {
    const { token } = theme.useToken();
    return (
        <div
            role="button"
            tabIndex={0}
            aria-pressed={active}
            onClick={onClick}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } }}
            style={{
                position: 'relative', boxSizing: 'border-box', cursor: 'pointer', height: '100%', padding: active ? 19 : 20,
                borderRadius: token.borderRadiusLG,
                border: `${active ? 2 : 1}px solid ${active ? token.colorPrimary : token.colorBorderSecondary}`,
                background: active ? token.colorPrimaryBg : token.colorBgContainer,
                transition: 'border-color .15s, background .15s',
            }}
        >
            {active && <CheckCircleFilled style={{ position: 'absolute', top: 12, right: 12, color: token.colorPrimary, fontSize: 16 }} />}
            {icon && <div style={{ fontSize: 24, color: token.colorPrimary, marginBottom: 8 }}>{icon}</div>}
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, paddingRight: 20, marginBottom: 4 }}>
                <span style={{ fontWeight: 600, fontSize: 15 }}>{title}</span>
                {extra && <span style={{ marginLeft: 'auto', fontWeight: 600, color: token.colorPrimary }}>{extra}</span>}
            </div>
            {desc && <Text type="secondary" style={{ fontSize: 13 }}>{desc}</Text>}
            {children}
        </div>
    );
};

/** 每一步的标题 */
export const StepHead = ({ title, desc }) => (
    <div style={{ marginBottom: 24 }}>
        <Typography.Title level={4} style={{ margin: 0 }}>{title}</Typography.Title>
        {desc && <Text type="secondary">{desc}</Text>}
    </div>
);
